import { createSlice } from "@reduxjs/toolkit";

const initialState = { 
  medical_test_table : [],
};
const medicaltestReducer = createSlice({
  name: "medicalTestReducer",
  initialState,
  reducers: {
    addMedicalTest(state,action){
        state.medical_test_table=[...state.medical_test_table,...action.payload]
    },
    removeMedicalTest(state,action){
       state.medical_test_table=state.medical_test_table.splice(action.payload,1)
    }
  },
});
export const { addMedicalTest,removeMedicalTest} = medicaltestReducer.actions;
export default medicaltestReducer.reducer;
